import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export type PumpModeSlice = {
  durationMinutes: number;
  percentage: number;
};

export type PumpModeIndicators = {
  auto: PumpModeSlice;
  manual: PumpModeSlice;
  totalMinutes: number;
};

const pumpModeSliceSchema: Schema<PumpModeSlice> = cz.camelCaseObject({
  duration_minutes: z.number(),
  percentage: z.number(),
});

const pumpModeIndicatorsDataSchema: Schema<PumpModeIndicators> = cz.camelCaseObject({
  auto: pumpModeSliceSchema,
  manual: pumpModeSliceSchema,
  total_minutes: z.number(),
});

export const pumpModeIndicatorsSchema: Schema<PumpModeIndicators | null> = cz.noContent(pumpModeIndicatorsDataSchema);
